import React from "react";

// Components
import {FormPageLayout} from "../../components/layout/FormPageLayout";
import {UserUsageTermsFeature} from "../../features/userUsageTerms";

const UserUsageTermsPage = () => (
  <FormPageLayout
    body={
      <UserUsageTermsFeature />
    }
  />
)

export default UserUsageTermsPage;
